<template>
	<div class="item_sidebar" >
		<div class="title title_m_b layout-row" v-once>
			{{ title }}
			<keep-alive>
				<info-icon>
					<span> Select an action to trigger when the element is clicked.</span>
				</info-icon>
			</keep-alive>
		</div>
		<div class="item mb_10">
			<v-select class="select2_itemx "
			          :options="options"
			          :searchable="false"
			          :clearable="false"
			          label="label"
			          :reduce="x => x.id"
			          :value="clickActionData.mainToggle"
			          @input="selectUpdate($event, 'mainToggle')"
			          append-to-body>
				<template v-slot:option="option">
					<div class="layout-column">
						<span style="font-weight: bold">{{ option.label }}</span>
						<span>{{ option.description }}</span>
					</div>
				</template>
			</v-select>
		</div>

		<div v-if="clickActionData.mainToggle==='goto'">
			<input-field small placeholder="Enter your url" v-model="clickActionData.url"
			             @change="urlUpdate($event)"/>

			<v-switch label="Open in a new tab"
			          :value="clickActionData.target==='_blank'" @change="urlUpdateTarget($event)" />
		</div>
	</div>
</template>

<script>
import InfoIcon from '@/components/base/info-icon';
import SelectField from '@/components/base/select-field';
import InputField from '@/components/base/input-field';
import VSwitch from '@/components/base/v-switch';
import {mapGetters, mapState} from "vuex"

export default {
	name: 'ExpireAction',
	props: ["value", "title"],
	components: {InfoIcon, SelectField, InputField, VSwitch},
	data: function () {
		return {
			// mainSelectOptions: this.value.mainSelectOptions,
			options:
					[
						{ id: '', label: 'No action', description:'Nothing happens when the timer expires.' },
						{ id: 'goto', label: 'Go to URL', description:'Goes to a given URL, in same tab or opens a new window/tab.' },
						{ id: 'hide', label: 'Hide countdown timer', description:'Hides the timer when it expires.' },
					],
			inputUrl: '',
			clickActionData: {
				element: '', // element id to go to, #890
				target: '_blank',
				url: '',
				mainToggle: 'No action'
			},
		}
	},
	computed: {
		...mapGetters(['page_findAll']),
		sctionsIDs() {
			var returnArray = [];

			for (let index = 0; index < this.page_findAll().length; index++) {
				let section = this.page_findAll()[index];
				returnArray.push({id: '', label: '', description:''});

				let title = section.attributes.advanced && section.attributes.advanced.title ?
						section.attributes.advanced.title : '';

				returnArray[index].id = '#' + section.id;
				returnArray[index].label = '#' + section.id;
				returnArray[index].description = title;
			}
			return returnArray;
		}
	},
	methods: {
		selectUpdate(id, varName) {
			this.clickActionData[varName] = id;

			this.$emit('updated', this.clickActionData);
		},
		urlUpdate(val) {
			this.clickActionData.url = val;

			this.$emit('updated', this.clickActionData);
		},
		urlUpdateTarget(val) {
			this.clickActionData.target = val ? '_blank' : '';
			this.$emit('updated', this.clickActionData);
		}
	},
	created() {
		this.clickActionData = JSON.parse(JSON.stringify(this.value));
	}
}
</script>
